import React from 'react';
import comparatorOptions from 'utils/const/comparatorOptions';
import InputField from 'components/pure/utils/form/InputField';
import SelectField from 'components/pure/utils/form/SelectField';
import './PercentageTriggerActionSelector.styl';
import ConstValues from 'utils/const';

export default ({
  selectedComparator,
  selectedComparisonValue,
  selectedAntiRule,
  selectedPeriodOption,
  onComparatorChange,
  onComparisonChange,
  rule,
}) => {
  const antiRuleShort = selectedAntiRule && selectedAntiRule.antiRuleShortName;
  return (
    <div className="percentage-trigger-action-selector">
      When the percentage of times that this event occurs over a {selectedPeriodOption.label} period
      is:
      <div className="inputs">
        <SelectField
          hideResetButton
          className="comparator-options"
          options={comparatorOptions}
          value={selectedComparator}
          onChange={onComparatorChange}
          dropdownDirection={ConstValues.reactSelectize.dropdownDirection.up}
        />
        <InputField
          value={selectedComparisonValue || ''}
          placeholder="30"
          type="number"
          onChange={onComparisonChange}
        />
        %{' '}
      </div>
      <span>
        of the "{antiRuleShort}" measurement over {selectedPeriodOption.label.toLowerCase()}
      </span>
    </div>
  );
};
